import { SearchForSchoolUrl } from './api-requests/api-request'
import { ISchool } from '../interfaces/school.interface'
import { HelpersNamespace } from './helpers'
import { getHost } from './client/getHost'

export const schoolGetClientSidedPropsUtil = async (): Promise<{
  schoolDetails?: ISchool | null
  host?: string
  error?: boolean
}> => {
  const host = getHost()
  if (!host) {
    return { schoolDetails: null, error: true }
  }

  if (HelpersNamespace.isAnIpadress(host)) {
    // Prevent unnecessary backend calls for raw IP access just like the server util did.
    return { schoolDetails: null, host, error: true }
  }

  try {
    const res = await SearchForSchoolUrl(host)
    const schoolDetails = (res?.data?.data as ISchool | null) || null
    return {
      schoolDetails,
      host,
    }
  } catch (err) {
    console.error('Error fetching school details client-side', err)
    return { schoolDetails: null, host, error: true }
  }
}

export default schoolGetClientSidedPropsUtil
